import FormStepperRouter from "../../../../templates/src/Components/FormStepper/FormStepper.router";
import {gsap} from "gsap";
import App from "../../../../templates/src/App/App";
import Scroller from "../../../../templates/src/Scroller/Scroller";
import Calculator from "./Calculator";
import FormStepper from "../../../../templates/src/Components/FormStepper/FormStepper";
import FormStepperSlider from "../../../../templates/src/Components/FormStepper/FormStepper.slider";

const CalculatorIntro = {
    init(el) {
        this.el = el;
        if (!this.el.length) return;

        this.button = this.el.find('button.start');
        this.headline = this.el.find('.headline');
        this.bind();
        // if (FormStepperRouter.path.length === 1) this.show();
    },

    bind() {
        this.button.click(() => {
            this.show();
        })
    },

    show() {
        this.el.addClass('active');
        this.headline.addClass('hidden');
        const height = FormStepper.slides.filter('.active').outerHeight();

        gsap.to(this.headline, {height: 0});
        gsap.set(Calculator.calc, {height: 'auto'})
        gsap.fromTo(FormStepper.main, {height: 0}, {height:height, duration:0.5})

        Calculator.calc.removeClass('hidden').addClass('active');

        // setTimeout(()=>{
        //     this.scroll();
        // },500)

        // Calculator.resize();
    },

    scroll() {
        if (!App.isMobile) return;
        const y = Calculator.calc.offset().top;
        console.log(y)

        gsap.to(window, {
            duration: Scroller.animTime,
            scrollTo: {y: y, offsetY: 0},
        });
    },

}

export default CalculatorIntro;
